import { getCookie } from '@r-client/shared/util/core';

const prefixedName = (prefix: string | undefined, name: string) =>
  prefix ? `${prefix}-${name}` : name;

export const getExpirationCookie = (prefix: string | undefined) => {
  return getCookie(prefixedName(prefix, 'republic-auth-expiration'));
};

export const isMobileWebView = () => {
  return !!getCookie('mobile_app_version');
};
